'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { useLanguage } from '@/lib/config/useLanguage';
import StaticBreadcrumbWrapper from './StaticBreadcrumbWrapper';

interface StaticBreadcrumbClientProps {
  pageTitle?: string;
}

export default function StaticBreadcrumbClient({
  pageTitle,
}: StaticBreadcrumbClientProps) {
  const pathname = usePathname() || '/';
  const { langCode } = useLanguage();

  return (
    <StaticBreadcrumbWrapper
      pathname={pathname}
      langCode={langCode}
      pageTitle={pageTitle}
    />
  );
}

